import { useEffect, useMemo, useState } from 'react';
import axios from 'common/AxiosAuth';
import { Grid, Text } from 'components';
import { DownlinkFileItem } from 'pages/Dashboard/types';
import { downlinkFileGridColumns } from 'pages/Dashboard/dashboardColumns';

export const DownlinkFileSection = () => {
  const [data, setData] = useState<DownlinkFileItem[]>([]);

  useEffect(() => {
    axios
      .get('/api/dashboard/downlink/file')
      .then((res) => setData(res.data.data))
      .catch((err) => console.error('다운링크 파일 조회 실패', err));
  }, []);

  return (
    <div className="min-w-0 flex-1 overflow-hidden rounded-xl border border-border-primary bg-bg-layer3">
      <div className="border-b border-border-primary p-4">
        <Text size="body2" weight="semibold" color="primary">
          Downlink File Management
        </Text>
      </div>

      {data.length === 0 ? (
        <div className="flex h-80 items-center justify-center text-sm text-secondary text-center">
          There are currently no downloadable files.
        </div>
      ) : (
        <div className="overflow-x-auto">
          <Grid
            gridColumns={downlinkFileGridColumns}
            gridData={data}
            options={{
              useCheckbox: false,
              usePagination: { use: false, maxPage: 1 },
              customCell: {
                downloadLink: (_, row) => (
                  <a
                    href={
                      row.downloadLink.startsWith('http')
                        ? row.downloadLink
                        : `https://${row.downloadLink}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex h-8 items-center justify-center rounded border border-primary bg-button-bg_primary px-3 text-sm text-white hover:bg-primary-dark transition"
                  >
                    Download
                  </a>
                ),
              },
            }}
            className="border-none"
          />
        </div>
      )}
    </div>
  );
};